import { API_URL } from './config';

// --- Helper: Get Token ---
const getToken = () => localStorage.getItem('token');

// --- Core Request Handler ---
export async function request(endpoint, { method = 'GET', body = null, isBlob = false } = {}) {
  const token = getToken();
  const headers = {};

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const config = {
    method,
    headers,
  };

  if (body) {
    if (body instanceof FormData) {
      config.body = body;
    } else {
      headers['Content-Type'] = 'application/json';
      config.body = JSON.stringify(body);
    }
  }

  try {
    const response = await fetch(`${API_URL}${endpoint}`, config);

    // Handle Auth Errors
    if (response.status === 401) {
      console.error("Session expired. Please login again.");
      throw new Error('Unauthorised');
    }
    if (response.status === 403) {
      throw new Error('Access Denied: You do not have permission to view this.');
    }

    // Handle Blob (File Downloads)
    if (isBlob) {
      if (!response.ok) throw new Error('Download failed');
      return await response.blob();
    }

    // Handle JSON Errors
    if (!response.ok) {
      let errorMessage = 'Server error';
      try {
        const errorJson = await response.json();
        errorMessage = errorJson.error || errorJson.message || response.statusText;
      } catch (e) {
        errorMessage = response.statusText;
      }
      const error = new Error(errorMessage);
      error.status = response.status;
      error.response = { data: { error: errorMessage } };
      throw error;
    }

    return await response.json();
  } catch (error) {
    console.error(`API Request Failed: ${endpoint}`, error);
    throw error;
  }
}
